import { SortByFn } from 'react-table';
import moment from 'moment';

import { PublishActualResultsTableData } from '../../../../../re-ducks/themes/types';

const sortDate: SortByFn<PublishActualResultsTableData> = (
  nextRow,
  currentRow,
  columnId,
): 0 | 1 | -1 => {
  const columnKey = columnId as Extract<
    keyof PublishActualResultsTableData,
    string
  >;
  const next = nextRow.original[columnKey] as string;
  const current = currentRow.original[columnKey] as string;
  if (!next || !current) return -1;

  const nextDate = moment(next).toDate();
  const currentDate = moment(current).toDate();

  return moment(nextDate).isAfter(currentDate) ? 1 : -1;
};

export default sortDate;
